import { Injectable } from '@angular/core';
import {  MailMessage } from '../_types/mail-message';
import { Service } from 'src/app/core/jsonapi/service';
import { prop } from '@rxweb/reactive-form-validators';
import { MailMessageAttachment } from '../_types/mail-message-attachment';

@Injectable({
  providedIn: 'root'
})
export class MailMessageAttachmentService extends Service<MailMessageAttachment> {
  public override type = 'mailMessageAttachments';
  public override url = 'communications/mailMessageAttachments';
  

}
